<template>
    <div class="widget-calendar">
        <dashboardCard heading='Server Session Details' :data1="serverActiveMax" :data2="serverAliveMax"
            :data3="serverCreated" :data4="serverExpired">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
    name: "serverSessionDetail",
    components: {
        dashboardCard
    },
    data() {
        return {
            serverActiveMax: {},
            serverAliveMax: {},
            serverCreated: {},
            serverExpired: {},
        };
    },
    methods: {
        getServerActiveMax(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.serverActiveMax.value = JSON.parse(response.server.data[0].value);
                    this.serverActiveMax.name = 'Active Max';
                    this.serverActiveMax.description = 'Peak concurrent active sessions.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getServerAliveMax(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.serverAliveMax.value = response.server.data[0].value;
                    this.serverAliveMax.name = 'Alive Max';
                    this.serverAliveMax.description = 'Longest session duration.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getServerCreated(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.serverCreated.value = response.server.data[0].value;
                    this.serverCreated.name = 'Created';
                    this.serverCreated.description = 'Total sessions created.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getServerExpired(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.serverExpired.value = response.server.data[0].value;
                    this.serverExpired.name = 'Expired';
                    this.serverExpired.description = 'Total sessions expired.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.getServerExpired("SERVER_SESSION_EXPIRED");
        this.getServerCreated("SERVER_SESSION_CREATED");
        this.getServerAliveMax("SERVER_SESSION_ALIVE_MAX");
        this.getServerActiveMax("SERVER_SESSION_ACTIVE_MAX");
    }
};
</script>